import { useRef, useState, useContext } from 'preact/hooks';
import { ChatContext } from '../hooks/context.js';
import { showReview } from '../store/chatStore.js';

const EMOJIS = [
  { rating: 1, label: 'Very Bad',  emoji: '😡' },
  { rating: 2, label: 'Bad',       emoji: '😞' },
  { rating: 3, label: 'Normal',    emoji: '😐' },
  { rating: 4, label: 'Good',      emoji: '😊' },
  { rating: 5, label: 'Very Good', emoji: '😍' },
];

export function ReviewPrompt({ visible, isFloatpanel, onScrollBottom }) {
  const { cfg, api, session, bus, analytics } = useContext(ChatContext);
  const [selected, setSelected]     = useState(null);
  const [showComment, setShowComment] = useState(false);
  const [thanked, setThanked]       = useState(false);
  const commentRef = useRef(null);

  if (!visible) return null;

  const handleClose = () => { showReview.value = false; };

  const handleEmoji = (item) => {
    setSelected(item);
    setShowComment(true);
    setTimeout(() => {
      commentRef.current?.focus();
      onScrollBottom?.();
    }, 50);
  };

  const handleSubmit = async () => {
    if (!selected) return;
    const comment    = commentRef.current?.value?.trim() || null;
    const sessionId  = session.getOrCreate().sessionId;

    setThanked(true);
    setTimeout(() => { showReview.value = false; }, 5000);

    analytics?.track('/chat/session/review', {
      session_id:  sessionId,
      app_id:      cfg.appId,
      rating:      selected.rating,
      emoji_label: selected.label,
      comment:     comment || null,
    }, 'review');

    bus.emit('review', { sessionId, rating: selected.rating, label: selected.label, comment });
  };

  const wrapClass = isFloatpanel ? 'mc-greview mc-review-prompt' : 'mc-review-prompt';

  if (thanked) {
    return (
      <div class={wrapClass} aria-label="Rate this conversation">
        <p class="mc-review-thanks">
          Thanks for your feedback! {selected?.label === 'Very Good' || selected?.label === 'Good' ? '😊' : '🙏'}
        </p>
      </div>
    );
  }

  return (
    <div class={wrapClass} aria-label="Rate this conversation">
      <div class="mc-review-header">
        <p class="mc-review-label">How was your experience?</p>
        <button class="mc-review-close" aria-label="Dismiss" title="Dismiss" onClick={handleClose}>&#x2715;</button>
      </div>
      <div class="mc-review-emojis">
        {EMOJIS.map(item => (
          <button
            key={item.rating}
            class={`mc-review-btn${selected?.rating === item.rating ? ' mc-selected' : ''}`}
            data-rating={item.rating}
            data-label={item.label}
            title={item.label}
            onClick={() => handleEmoji(item)}
          >
            {item.emoji}
          </button>
        ))}
      </div>
      {showComment && (
        <div class="mc-review-comment-wrap">
          <textarea
            ref={commentRef}
            class="mc-review-textarea"
            rows={2}
            placeholder="Add a comment (optional)"
            maxLength={500}
            aria-label="Review comment"
          />
          <button class="mc-review-submit" aria-label="Submit review" onClick={handleSubmit}>Submit</button>
        </div>
      )}
    </div>
  );
}
